export var ElectronicHookSwitchAttribute;
(function (ElectronicHookSwitchAttribute) {
    ElectronicHookSwitchAttribute["Key"] = "Meta_Accessorytype";
    ElectronicHookSwitchAttribute["Value"] = "Electronic_Hook_Switch";
})(ElectronicHookSwitchAttribute || (ElectronicHookSwitchAttribute = {}));
